import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';

const SPR = true;

const routes: Routes = [
  {
    path: '',
    component: NavbarComponent,
    // canActivate: [AuthGuard], // * Caso o projeto tenha rotas sem auth além de login, remover essa linha.
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'about',
        loadChildren: () =>
          import('./pages/about/about.module').then((m) => m.AboutModule),
      },
      {
        path: 'news',
        loadChildren: () =>
          import('./pages/news/news.module').then((m) => m.NewsModule),
      },
      {
        path: 'possessions',
        loadChildren: () =>
          import('./pages/possessions/possessions.module').then(
            (m) => m.PossessionsModule
          ),
      },
      {
        path: 'auction-schedule',
        loadChildren: () =>
          import('./pages/auction-schedule/auction-schedule.module').then(
            (m) => m.AuctionScheduleModule
          ),
      },
      {
        path: 'streaming',
        loadChildren: () =>
          import('./pages/live-bidding/live-bidding.module').then(
            (m) => m.LiveBiddingModule
          ),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./pages/contact/contact.module').then((m) => m.ContactModule),
      },
      {
        path: 'register',
        loadChildren: () =>
          import('./pages/register/register.module').then(
            (m) => m.RegisterModule
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'auction',
        loadChildren: () =>
          import('./pages/auction/auction.module').then((m) => m.AuctionModule),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./pages/forgot-password/forgot-password.module').then(
            (m) => m.ForgotPasswordModule
          ),
      },
      {
        path: 'set-password/:hash',
        loadChildren: () =>
          import('./pages/redefine-password/redefine-password.module').then(
            (m) => m.RedefinePasswordModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'streaming',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration : SPR ? 'enabled' : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
